import Vue from "vue";
import Vuex from "vuex";
import departmentStore from './modules/departmentStore';
import basicInfoModule from "./modules/basicInfoModule";
import workInfoModule from "./modules/workInfoModule";
import patentInfoModule from "./modules/patentInfoModule";
import paperInfoModule from "./modules/paperInfoModule";
import subjectInfoModule from "./modules/subjectInfoModule";
import codeDictModule from "./modules/codeDictModule";
import userPowerStore from "./modules/userPowerStore";
import headerStore from "./modules/headerStore";
import userModule from "./modules/userModule";
import achiInfoModule from "./modules/AchiInfoModule";
import honorInfoModule from "./modules/honorInfoModule";
import talentInfoModule from "./modules/talentInfoModule";
import teacherInfoModule from "./modules/teacherInfoModule";
import memberAllInfoModule from "./modules/memberAllInfoModule";
import studyInfoModule from "./modules/studyInfoModule";
import teachingInfoModule from "./modules/teachingInfoModule";
import gcpInfoModule from "./modules/gcpInfoModule";
import awardInfoModule from "./modules/awardInfoModule";
import appointmentInfoModule from "./modules/appointmentInfoModule";
import graduateInfoModule from "./modules/graduateInfoModule";
import meetingInfoModule from "./modules/meetingInfoModule";
import trainingInfoModule from "./modules/trainingInfoModule";
import lectureInfoModule from "./modules/lectureInfoModule";
import volunteerInfoModule from "./modules/volunteerInfoModule";
import studioInfoModule from "./modules/studioInfoModule";
import guideInfoModule from "./modules/guideInfoModule";
import centerInfoModule from "./modules/centerInfoModule";
import articleInfoModule from "./modules/articleInfoModule";
import lecture2InfoModule from "./modules/lecture2InfoModule";
import qualityInfoModule from "./modules/qualityInfoModule";
import allianceInfoModule from "./modules/allianceInfoModule";
import memberDepartmentModule from "./modules/memberDepartmentModule";
import pendingItemListModule from "./modules/pendingItemListModule";
import LoudSpeakerModule from "./modules/LoudSpeakerModule";
import caseShareModule from "./modules/caseShareModule";
import searchConditionModule from "./modules/searchConditionModule";
import MemberManageModule from "./modules/MemberManageModule"


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    departmentStore,
    basicInfoModule,
    workInfoModule,
    patentInfoModule,
    paperInfoModule,
    subjectInfoModule,
    honorInfoModule,
    talentInfoModule,
    teacherInfoModule,
    codeDictModule,
    userPowerStore,
    headerStore,
    userModule,
    achiInfoModule,
    memberAllInfoModule,
    teachingInfoModule,
    gcpInfoModule,
    awardInfoModule,
    studyInfoModule,
    appointmentInfoModule,
    graduateInfoModule,
    meetingInfoModule,
    trainingInfoModule,
    lectureInfoModule,
    volunteerInfoModule,
    studioInfoModule,
    guideInfoModule,
    articleInfoModule,
    lecture2InfoModule,
    qualityInfoModule,
    allianceInfoModule,
    centerInfoModule,
    memberDepartmentModule,
    pendingItemListModule,
    LoudSpeakerModule,
    searchConditionModule,
    caseShareModule,
    MemberManageModule,
  },
})



// WEBPACK FOOTER //
// ./src/vuex/store.js